import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '@app/core/route.service';
import { DeviceComponent } from './device.component';

const routes: Routes = Route.withShell([
  { path: 'device', component: DeviceComponent, data: { title: 'Device' } }
]);

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule],
  declarations: []
})
export class DeviceRoutingModule { }
